import { Row } from "antd";
import React from "react";
import {
  Controller,
  FieldError,
  RegisterOptions,
  useFormContext,
} from "react-hook-form";
import { Textarea } from "../components/uielements/input";
import ErrorInputMessage from "./ErrorInputMessage";

type Props = {
  name: string;
  label?: string;
  rules?: RegisterOptions;
  placeholder?: string;
  error?: FieldError;
  style?: any;
  type?: string;
};
const TextAreaController = ({
  name,
  error,
  label,
  rules,
  placeholder,
  style,
  ...rest
}: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const fieldError = error ? error : errors && errors[name];
  return (
    <Row>
      {label && <h4>{label}</h4>}
      <Controller
        control={control}
        rules={rules}
        name={name}
        render={({ field }) => (
          <Textarea
            {...field}
            placeholder={placeholder ? placeholder : label?.toLowerCase()}
            style={style}
            {...rest}
          />
        )}
      />
      <ErrorInputMessage error={fieldError as any} />
    </Row>
  );
};

export default TextAreaController;
